<template>
	<div class="row">



		<!-- RESPONSE -->
		<div class="col-12" v-if="state === 'success' || state === 'fail'">
			<div class="row">
				<div class="col-12">
					<div class="account__block__title">{{ t('user.page.payin.title.'+state) }}</div>
				</div>
			</div>
			<div class="block block--visible">
				<div class="block__content account__block__content__payin">
					<div class="row">
						<div class="col-12 account__block__content__payin--response">
							<h1 v-html="t('user.page.payin.text.'+state)">

							</h1>
						</div>
					</div>
					<div class="row">
						<div class="col-12 d-flex align-items-center justify-content-center mb-5">
							<router-link :to="{name: 'User'}" class="btn btn-primary">{{t('user.page.payin.btn.response')}}</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>


	export default {
		name: 'UserPayinResponse',
		components:{

		},
		data() {
			return {

			}
		},
		computed:{
			state(){

				return  this.$route.params['status'].toLowerCase();

			}
		},
		mounted(){
			if( !(this.state === 'success' || this.state === 'fail')){
				this.router.push({name: 'UserPayin'});
			}
		},
		methods:{

		}

	}
</script>